import { useState } from "react";
import { recordBetaFeedback } from "../../js/api/betaFeedback";
import { useAuth } from "../../js/hooks/useAuth";

export default function BetaFeedbackWidget({ compact = false }) {
  const { session } = useAuth();
  const [text, setText] = useState("");
  const [note, setNote] = useState("");

  if (!session?.betaTester) return null;

  function handleSubmit(event) {
    event.preventDefault();
    if (!text.trim()) return;
    recordBetaFeedback({ session, message_text: text, mirrorToOffice: true });
    setText("");
    setNote("Received. Thank you — the program desk will see this.");
  }

  return (
    <section className={`suggest-widget${compact ? " suggest-widget--compact" : ""}`}>
      <h3>A note for the team</h3>
      <p className="muted">
        Send a thought anytime. It reaches the program desk, and a copy is kept with your office
        messages.
      </p>
      <form onSubmit={handleSubmit}>
        <label className="field">
          <span className="field-label">Your note</span>
          <textarea
            className="field-textarea"
            rows={compact ? 3 : 4}
            value={text}
            onChange={(event) => setText(event.target.value)}
          />
        </label>
        <button type="submit" className="primary-btn">
          Send a note
        </button>
      </form>
      {note ? <p className="muted">{note}</p> : null}
    </section>
  );
}
